import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

/* Layout */
import Layout from '../views/layout/Layout';
import wapLayout from '../views/wap/index';

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '/wap',
    component: wapLayout,
    hidden: true,
    redirect: '/wap/orderList',
    children: [
      {
        path: 'orderNav',
        name: 'orderNav',
        hidden: true,
        component: () => import('@/views/wap/nav'),
        meta: { title: 'nav', icon: 'home' }
      },
      {
        path: 'orderList',
        name: 'orderList',
        hidden: true,
        component: () => import('@/views/wap/orderList'),
        meta: { title: 'order list', icon: 'home', keepLive: true }
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        hidden: true,
        component: () => import('@/views/wap/orderDetail'),
        meta: { title: 'order detail', icon: 'home' }
      },
      {
        path: 'productList',
        name: 'productList',
        hidden: true,
        component: () => import('@/views/wap/product'),
        meta: { title: 'product list', icon: 'home', keepLive: true }
      },
      {
        path: 'productAdd',
        name: 'productAdd',
        hidden: true,
        component: () => import('@/views/wap/productAdd'),
        meta: { title: 'product add', icon: 'home' }
      },
      {
        path: 'userAdd',
        name: 'userAdd',
        hidden: true,
        component: () => import('@/views/wap/userAdd'),
        meta: { title: 'user add', icon: 'home' }
      }
    ]
  },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home/index'),
        meta: { title: 'home', icon: 'home' }
      }
    ]
  }
];

export const asyncRouterMap = [
  {
    path: '',
    component: Layout,
    redirect: '/report',
    meta: {
      title: 'report',
      icon: 'report'
    },
    name: 'report',
    children: [
      {
        path: 'bossReport',
        name: 'bossReport',
        component: () => import('@/views/home/staticis'),
        meta: { title: 'bossReport', icon: 'order' }
        // hidden: true
      }
    ]
  },
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: { title: 'product', icon: 'product' },
    children: [
      {
        path: 'product',
        name: 'product',
        component: () => import('@/views/pms/product/index'),
        meta: { title: 'productList', icon: 'product-list', keepLive: true }
      },
      {
        path: 'productListVirtual',
        name: 'productListVirtual',
        component: () => import('@/views/pms/product/productListVirtual'),
        meta: { title: 'productListVirtual', icon: 'product-list', keepLive: true }
      },
      {
        path: 'activityList',
        name: 'productActivityList',
        component: () => import('@/views/pms/activityList'),
        meta: { title: 'productActivity', icon: 'product-list', keepLive: true }
      },
      {
        path: 'rate-calculator',
        name: 'rate-calculator',
        component: () => import('@/views/pms/rateCalculator'),
        meta: { title: 'rateCalculator', icon: 'product-list', keepLive: true }
      },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/pms/product/add'),
        meta: { title: 'addProduct', icon: 'product-add' }
      },
      // {
      //   path: 'addSimple',
      //   name: 'addSimple',
      //   component: () => import('@/views/pmc/product/addSimple'),
      //   meta: { title: 'addProduct', icon: 'addProduct' },
      //   hidden: true
      // },
      {
        path: 'addSalesLink',
        name: 'addSalesLink',
        component: () => import('@/views/wap/productAdd'),
        meta: { title: 'addSalesLink', icon: 'product-add' }
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/product/update'),
        meta: { title: 'modifyProduct', icon: 'product-add' },
        hidden: true
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: { title: 'productCategories', icon: 'product-cate' }
      },
      {
        path: 'productCate?parentId=53',
        name: 'productBagsCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: { title: 'productBagCategories', icon: ' ' }
      },
      {
        path: 'productCate?parentId=65',
        name: 'productAccessoriesCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: { title: 'productAccessoriesCategories', icon: ' ' }
      },
      {
        path: 'productCate?parentId=66',
        name: 'productFashionCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: { title: 'productFashionCategories', icon: ' ' }
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: { title: 'addProductCategories' },
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: { title: 'modifyProductCategories' },
        hidden: true
      },
      {
        path: 'productAttr',
        name: 'productAttr',
        component: () => import('@/views/pms/productAttr/index'),
        meta: { title: 'productType', icon: 'product-attr' }
      },

      {
        path: 'productAttrCode',
        name: 'productAttrCode',
        component: () => import('@/views/pms/productAttrCode/index'),
        meta: { title: 'productAttrCode', icon: 'product-attr' },
        hidden: true
      },

      {
        path: 'productAttrCode?name=type',
        name: 'productAttributeCodeType',
        component: () => import('@/views/pms/productAttrCode/index'),
        meta: { title: 'productAttributeCodeType', icon: ' ' }
      },
      {
        path: 'productAttrCode?name=color',
        name: 'productAttributeCodeColor',
        component: () => import('@/views/pms/productAttrCode/index'),
        meta: { title: 'productAttributeCodeColor', icon: ' ' }
      },
      {
        path: 'productAttrCode?name=material&categoryId=53',
        name: 'productAttributeCodeBagMaterial',
        component: () => import('@/views/pms/productAttrCode/index'),
        meta: { title: 'productAttributeCodeBagMaterial', icon: ' ' }
      },
      {
        path: 'productAttrCode?name=material&categoryId=65',
        name: 'productAttributeCodeAccessoryMaterial',
        component: () => import('@/views/pms/productAttrCode/index'),
        meta: { title: 'productAttributeCodeAccessoryMaterial', icon: ' ' }
      },
      {
        path: 'productAttrCode?name=material&categoryId=66',
        name: 'productAttributeCodeFashionMaterial',
        component: () => import('@/views/pms/productAttrCode/index'),
        meta: { title: 'productAttributeCodeFashionMaterial', icon: ' ' }
      },
      {
        path: 'productAttrCode?name=hardware',
        name: 'productAttributeCodeHardware',
        component: () => import('@/views/pms/productAttrCode/index'),
        meta: { title: 'productAttributeCodeHardware', icon: ' ' }
      },
      {
        path: 'productAttrCode?name=stamp',
        name: 'productAttributeCodeStamp',
        component: () => import('@/views/pms/productAttrCode/index'),
        meta: { title: 'productAttributeCodeStamp', icon: ' ' }
      },
      {
        path: 'productAttrCode?name=accessories',
        name: 'productAttributeCodeAccessories',
        component: () => import('@/views/pms/productAttrCode/index'),
        meta: { title: 'productAttributeCodeAccessories', icon: ' ' }
      },
      {
        path: 'productAttrCode?name=collection&categoryId=53',
        name: 'productAttributeCodeBagCollection',
        component: () => import('@/views/pms/productAttrCode/index'),
        meta: { title: 'productAttributeCodeBagCollection', icon: ' ' }
      },
      {
        path: 'productAttrCode?name=collection&categoryId=65',
        name: 'productAttributeCodeAccessoryCollection',
        component: () => import('@/views/pms/productAttrCode/index'),
        meta: { title: 'productAttributeCodeAccessoryCollection', icon: ' ' }
      },
      {
        path: 'productAttrCode?name=collection&categoryId=66',
        name: 'productAttributeCodeFashionCollection',
        component: () => import('@/views/pms/productAttrCode/index'),
        meta: { title: 'productAttributeCodeFashionCollection', icon: ' ' }
      },
      {
        path: 'productAttrList',
        name: 'productAttrList',
        component: () => import('@/views/pms/productAttr/productAttrList'),
        meta: { title: 'productAttributeList' },
        hidden: true
      },
      {
        path: 'addProductAttr',
        name: 'addProductAttr',
        component: () => import('@/views/pms/productAttr/addProductAttr'),
        meta: { title: 'addProductAttribute' },
        hidden: true
      },
      {
        path: 'updateProductAttr',
        name: 'updateProductAttr',
        component: () => import('@/views/pms/productAttr/updateProductAttr'),
        meta: { title: 'editProductAttribute' },
        hidden: true
      },
      {
        path: 'brand',
        name: 'brand',
        component: () => import('@/views/pms/brand/index'),
        meta: { title: 'brandManagement', icon: 'product-brand' }
      },
      {
        path: 'addBrand',
        name: 'addBrand',
        component: () => import('@/views/pms/brand/add'),
        meta: { title: 'addBrand' },
        hidden: true
      },
      {
        path: 'updateBrand',
        name: 'updateBrand',
        component: () => import('@/views/pms/brand/update'),
        meta: { title: 'updateBrand' },
        hidden: true
      },
      {
        path: 'translateProductCate',
        name: 'translateProductCate',
        component: () => import('@/views/pms/productCate/translate'),
        meta: { title: 'translationProductCategory' },
        hidden: true
      },

      {
        path: 'translateProductBrand',
        name: 'translateProductBrand',
        component: () => import('@/views/pms/brand/translate'),
        meta: { title: 'translationProductBrand' },
        hidden: true
      },
      {
        path: 'translateProductAttributeCategory',
        name: 'translateProductAttributeCategory',
        component: () => import('@/views/pms/productAttr/translate'),
        meta: { title: 'translationProductType' },
        hidden: true
      },
      {
        path: 'translateProductAttribute',
        name: 'translateProductAttribute',
        component: () => import('@/views/pms/productAttr/translateAttrList'),
        meta: { title: 'translationProductTypeProperties' },
        hidden: true
      },
      {
        path: 'translateProduct',
        name: 'translateProduct',
        component: () => import('@/views/pms/product/translate'),
        meta: { title: 'translationProduct' },
        hidden: true
      },
      {
        path: 'syncSetting',
        name: 'syncSetting',
        component: () => import('@/views/pms/syncSetting/'),
        meta: { title: 'ftpPassword' }
      }
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: { title: 'order', icon: 'order' },
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: { title: 'orderList', icon: 'product-list', keepLive: true }
      },
      {
        path: 'orderListVirtual',
        name: 'orderListVirtual',
        component: () => import('@/views/oms/order/orderListVirtual'),
        meta: { title: 'orderListVirtual', icon: 'product-list', keepLive: true }
      },
      {
        path: 'createOrder',
        name: 'createOrder',
        component: () => import('@/views/oms/create-order/index'),
        meta: { title: 'createOrder', icon: 'product-add', keepLive: true }
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: { title: 'orderDetail' },
        hidden: true
      },
      {
        path: 'deliverOrderList',
        name: 'deliverOrderList',
        component: () => import('@/views/oms/order/deliverOrderList'),
        meta: { title: 'deliveryList', icon: 'product-list' },
        hidden: true
      },
      {
        path: 'returnApply',
        name: 'returnApply',
        component: () => import('@/views/oms/apply/index'),
        meta: { title: 'afterSaleList', icon: 'order-return' },
        hidden: true
      },
      {
        path: 'returnApplyDetail',
        name: 'returnApplyDetail',
        component: () => import('@/views/oms/apply/applyDetail'),
        meta: { title: 'afterSalesServiceListDetail' },
        hidden: true
      },
      {
        path: 'wantBook',
        name: 'wantBook',
        component: () => import('@/views/oms/wantBook/index'),
        meta: { title: 'outOfStockRegistration', icon: 'product-list', keepLive: true },
        hidden: false
      },
      {
        path: 'updateWantBook',
        name: 'updateWantBook',
        component: () => import('@/views/oms/wantBook/update'),
        meta: { title: 'updateOutOfStockRegistration' },
        hidden: true
      },
      {
        path: 'recycle',
        name: 'recycle',
        component: () => import('@/views/oms/recycle/index'),
        meta: { title: 'recyclingRegistration', icon: 'product-list' },
        hidden: false
      },
      {
        path: 'updateRecycle',
        name: 'updateRecycle',
        component: () => import('@/views/oms/recycle/update'),
        meta: { title: 'updateRecyclingRegistration' },
        hidden: true
      },
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/order/setting'),
        meta: { title: 'orderSetup', icon: 'order-setting' },
        hidden: true
      },
      {
        path: 'payments',
        name: 'payments',
        component: () => import('@/views/oms/payments/index'),
        meta: { title: 'paymentMethod', icon: 'product-list', keepLive: true },
        hidden: false
      },
      {
        path: 'addPayments',
        name: 'addPayments',
        component: () => import('@/views/oms/payments/add'),
        meta: { title: 'addPaymentMethod' },
        hidden: true
      },
      {
        path: 'updatePayments',
        name: 'updatePayments',
        component: () => import('@/views/oms/payments/update'),
        meta: { title: 'updatePaymentMethod' },
        hidden: true
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/apply/reason'),
        meta: { title: 'returnReasonSettings', icon: 'order-return-reason' },
        hidden: true
      },
      {
        path: 'companyAddress',
        name: 'companyAddress',
        component: () => import('@/views/oms/companyAddress/index'),
        meta: { title: 'shippingAddress', icon: 'product-list', keepLive: true },
        hidden: false
      },
      {
        path: 'updateCompanyAddress',
        name: 'updateCompanyAddress',
        component: () => import('@/views/oms/companyAddress/update'),
        meta: { title: 'updateShippingAddress' },
        hidden: true
      },
      {
        path: 'addCompanyAddress',
        name: 'addCompanyAddress',
        component: () => import('@/views/oms/companyAddress/add'),
        meta: { title: 'addShippingAddress' },
        hidden: true
      },
      {
        path: 'FeightTemplate',
        name: 'FeightTemplate',
        component: () => import('@/views/pms/feightTemplate/index'),
        meta: { title: 'feightTemplate', icon: 'product-list' },
        hidden: true
      },
      {
        path: 'addFeightTemplate',
        name: 'addFeightTemplate',
        component: () => import('@/views/pms/feightTemplate/add'),
        meta: { title: 'addFeightTemplate' },
        hidden: true
      },
      {
        path: 'updateFeightTemplate',
        name: 'updateFeightTemplate',
        component: () => import('@/views/pms/feightTemplate/update'),
        meta: { title: 'updateFeightTemplate' },
        hidden: true
      }
    ]
  },
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/member',
    name: 'ums',
    meta: { title: 'member', icon: 'home' },
    children: [
      {
        path: 'member',
        name: 'member',
        component: () => import('@/views/ums/member/index'),
        meta: { title: 'memberList', icon: 'product-list', keepLive: true }
      },
      {
        path: 'createMember',
        name: 'createMember',
        component: () => import('@/views/ums/member-create/index'),
        meta: { title: 'createMember', icon: 'product-add' }
      },
      {
        path: 'addMember',
        name: 'addMember',
        component: () => import('@/views/ums/member/add'),
        meta: { title: 'addMember' },
        hidden: true
      },
      {
        path: 'updateMember',
        name: 'updateMember',
        component: () => import('@/views/ums/member/update'),
        meta: { title: 'updateMember' },
        hidden: true
      },
      {
        path: 'memberLevel',
        name: 'memberLevel',
        component: () => import('@/views/ums/memberLevel/index'),
        meta: { title: 'memberLevel', icon: 'product-list', keepLive: true }
      },
      {
        path: 'addMemberLevel',
        name: 'addMemberLevel',
        component: () => import('@/views/ums/memberLevel/add'),
        meta: { title: 'addMemberLevel' },
        hidden: true
      },
      {
        path: 'updateMemberLevel',
        name: 'updateMemberLevel',
        component: () => import('@/views/ums/memberLevel/update'),
        meta: { title: 'updateMemberLevel' },
        hidden: true
      },
      {
        path: 'memberBlanceLog',
        name: 'memberBlanceLog',
        component: () => import('@/views/ums/memberBlanceLog/index'),
        meta: { title: 'memberPointsRecord', icon: 'product-list' },
        hidden: true
      },
      {
        path: 'addMemberBlanceLog',
        name: 'addMemberBlanceLog',
        component: () => import('@/views/ums/memberBlanceLog/add'),
        meta: { title: 'addMemberPointsRecord' },
        hidden: true
      },
      {
        path: 'memberIntegration',
        name: 'memberIntegration',
        component: () => import('@/views/ums/memberIntegration/index'),
        meta: { title: 'logRecordOfGrowthValue', icon: 'product-list' },
        hidden: true
      }
    ]
  },
  {
    path: '/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: { title: 'marketing', icon: 'sms' },
    children: [
      {
        path: 'advertise',
        name: 'homeAdvertise',
        component: () => import('@/views/sms/advertise/index'),
        meta: { title: 'advertisementList', icon: 'sms-ad', keepLive: true }
      },
      {
        path: 'addAdvertise',
        name: 'addHomeAdvertise',
        component: () => import('@/views/sms/advertise/add'),
        meta: { title: 'addAdvertisementList' },
        hidden: true
      },
      {
        path: 'updateAdvertise',
        name: 'updateHomeAdvertise',
        component: () => import('@/views/sms/advertise/update'),
        meta: { title: 'updateAdvertisementList' },
        hidden: true
      },
      {
        path: 'new',
        name: 'homeNew',
        component: () => import('@/views/sms/new/index'),
        meta: { title: 'newProductRecommendation', icon: 'sms-new' }
      },
      {
        path: 'hot',
        name: 'homeHot',
        component: () => import('@/views/sms/hot/index'),
        meta: { title: 'popularRecommendation', icon: 'sms-hot' }
      },
      {
        path: 'brand',
        name: 'homeBrand',
        component: () => import('@/views/sms/brand/index'),
        meta: { title: 'brandRecommendation', icon: 'product-brand', keepLive: true },
        hidden: true
      },
      {
        path: 'subject',
        name: 'homeSubject',
        component: () => import('@/views/sms/subject/index'),
        meta: { title: 'specialTopicRecommendation', icon: 'sms-subject', keepLive: true },
        hidden: true
      },
      {
        path: 'flash',
        name: 'flash',
        component: () => import('@/views/sms/flash/index'),
        meta: { title: 'seckillActivityList', icon: 'sms-flash' },
        hidden: true
      },
      {
        path: 'flashSession',
        name: 'flashSession',
        component: () => import('@/views/sms/flash/sessionList'),
        meta: { title: 'seckillTimePeriodList' },
        hidden: true
      },
      {
        path: 'selectSession',
        name: 'selectSession',
        component: () => import('@/views/sms/flash/selectSessionList'),
        meta: { title: 'secondKillTimePeriodSelection' },
        hidden: true
      },
      {
        path: 'flashProductRelation',
        name: 'flashProductRelation',
        component: () => import('@/views/sms/flash/productRelationList'),
        meta: { title: 'secondKillProductList' },
        hidden: true
      },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/coupon/index'),
        meta: { title: 'couponList', icon: 'sms-coupon' },
        hidden: false
      },
      {
        path: 'addCoupon',
        name: 'addCoupon',
        component: () => import('@/views/sms/coupon/add'),
        meta: { title: 'addCoupon' },
        hidden: true
      },
      {
        path: 'updateCoupon',
        name: 'updateCoupon',
        component: () => import('@/views/sms/coupon/update'),
        meta: { title: 'updateCoupon' },
        hidden: true
      },
      {
        path: 'couponHistory',
        name: 'couponHistory',
        component: () => import('@/views/sms/coupon/history'),
        meta: { title: 'couponCollectionDetails' },
        hidden: true
      },
      {
        path: 'couponMember',
        name: 'couponMember',
        component: () => import('@/views/sms/coupon/member'),
        meta: { title: 'couponCollectionDetails' },
        hidden: false
      },
      {
        path: 'couponLadder',
        name: 'couponLadder',
        component: () => import('@/views/sms/coupon/ladder'),
        meta: { title: 'couponCollectionDetails' },
        hidden: true
      }
    ]
  },
  {
    path: '/cms',
    component: Layout,
    redirect: '/cms/help',
    name: 'cms',
    meta: { title: 'content', icon: 'home' },
    children: [
      {
        path: 'subjectCategory',
        name: 'subjectCategory',
        component: () => import('@/views/cms/subjectCategory/index'),
        meta: { title: 'subjectCategory', icon: 'product-list', keepLive: true }
      },
      {
        path: 'addSubjectCategory',
        name: 'addSubjectCategory',
        component: () => import('@/views/cms/subjectCategory/add'),
        meta: { title: 'addPermission' },
        hidden: true
      },
      {
        path: 'updateSubjectCategory',
        name: 'updateSubjectCategory',
        component: () => import('@/views/cms/subjectCategory/update'),
        meta: { title: 'updatePermission' },
        hidden: true
      },
      {
        path: 'subject',
        name: 'subject',
        component: () => import('@/views/cms/subject/index'),
        meta: { title: 'listOfSubject', icon: 'product-list', keepLive: true }
      },
      {
        path: 'translateSubject',
        name: 'translateSubject',
        component: () => import('@/views/cms/subject/translate'),
        meta: { title: 'translateSubject' },
        hidden: true
      },
      {
        path: 'subjectProductRelation',
        name: 'subjectProductRelation',
        component: () => import('@/views/cms/subject/productRelationList'),
        meta: { title: 'productList', icon: 'product-list' },
        hidden: true
      },
      {
        path: 'addSubject',
        name: 'addSubject',
        component: () => import('@/views/cms/subject/add'),
        meta: { title: 'addSubject' },
        hidden: true
      },
      {
        path: 'updateSubject',
        name: 'updateSubject',
        component: () => import('@/views/cms/subject/update'),
        meta: { title: 'updateSubject' },
        hidden: true
      },
      {
        path: 'prefrenceArea',
        name: 'prefrenceArea',
        component: () => import('@/views/cms/prefrenceArea/index'),
        meta: { title: 'optimizationZone', icon: 'product-list' },
        hidden: true
      },
      {
        path: 'addPrefrenceArea',
        name: 'addPrefrenceArea',
        component: () => import('@/views/cms/prefrenceArea/add'),
        meta: { title: 'addOptimizationZone' },
        hidden: true
      },
      {
        path: 'updatePrefrenceArea',
        name: 'updatePrefrenceArea',
        component: () => import('@/views/cms/prefrenceArea/update'),
        meta: { title: 'updateOptimizationZone' },
        hidden: true
      },
      {
        path: 'topicCategory',
        name: 'topicCategory',
        component: () => import('@/views/cms/topicCategory/index'),
        meta: { title: 'topicCategory', icon: 'product-list', keepLive: true }
      },
      {
        path: 'addTopicCategory',
        name: 'addTopicCategory',
        component: () => import('@/views/cms/topicCategory/add'),
        meta: { title: 'addPermission' },
        hidden: true
      },
      {
        path: 'updateTopicCategory',
        name: 'updateTopicCategory',
        component: () => import('@/views/cms/topicCategory/update'),
        meta: { title: 'updatePermission' },
        hidden: true
      },
      {
        path: 'topic',
        name: 'topic',
        component: () => import('@/views/cms/topic/index'),
        meta: { title: 'topicList', icon: 'product-list', keepLive: true }
      },
      {
        path: 'addTopic',
        name: 'addTopic',
        component: () => import('@/views/cms/topic/add'),
        meta: { title: 'addPermission' },
        hidden: true
      },
      {
        path: 'updateTopic',
        name: 'updateTopic',
        component: () => import('@/views/cms/topic/update'),
        meta: { title: 'updatePermission' },
        hidden: true
      },
      {
        path: 'topicComment',
        name: 'topicComment',
        component: () => import('@/views/cms/topicComment/index'),
        meta: { title: 'topicCommentList', icon: 'product-list' },
        hidden: true
      },
      {
        path: 'helpCategory',
        name: 'helpCategory',
        component: () => import('@/views/cms/helpCategory/index'),
        meta: { title: 'helpCategory', icon: 'product-list', keepLive: true }
      },
      {
        path: 'addHelpCategory',
        name: 'addHelpCategory',
        component: () => import('@/views/cms/helpCategory/add'),
        meta: { title: 'addHelpCategory' },
        hidden: true
      },
      {
        path: 'updateHelpCategory',
        name: 'updateHelpCategory',
        component: () => import('@/views/cms/helpCategory/update'),
        meta: { title: 'updateHelpCategory' },
        hidden: true
      },
      {
        path: 'help',
        name: 'help',
        component: () => import('@/views/cms/help/index'),
        meta: { title: 'helpList', icon: 'product-list', keepLive: true }
      },
      {
        path: 'addHelp',
        name: 'addHelp',
        component: () => import('@/views/cms/help/add'),
        meta: { title: 'addHelp' },
        hidden: true
      },
      {
        path: 'updateHelp',
        name: 'updateHelp',
        component: () => import('@/views/cms/help/update'),
        meta: { title: 'updateHelp' },
        hidden: true
      },
      {
        path: 'auctionConfig',
        name: 'auctionConfig',
        component: () => import('@/views/cms/auction-config/index'),
        meta: { title: 'auctionConfig', icon: 'product-list', keepLive: true }
      }
    ]
  },
  {
    path: '/pos',
    component: Layout,
    redirect: '/pos/history',
    name: 'pos',
    meta: { title: 'point', icon: 'sms' },
    children: [
      {
        path: 'history',
        name: 'history',
        component: () => import('@/views/pos/history/index'),
        meta: { title: 'pointHistory', icon: 'ums-admin' }
      }
    ]
  },
  {
    path: '/sys',
    component: Layout,
    redirect: '/sys/admin',
    name: 'sys',
    meta: { title: 'system', icon: 'ums' },
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/sys/admin/index'),
        meta: { title: 'userList', icon: 'ums-admin' }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/sys/role/index'),
        meta: { title: 'roleList', icon: 'ums-role' }
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/sys/role/allocMenu'),
        meta: { title: 'assignmentMenu' },
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/sys/role/allocResource'),
        meta: { title: 'allocateResources' },
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/sys/menu/index'),
        meta: { title: 'menuList', icon: 'ums-menu' }
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/sys/menu/add'),
        meta: { title: 'addMenu' },
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/sys/menu/update'),
        meta: { title: 'updateMenu' },
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/sys/resource/index'),
        meta: { title: 'resourceList', icon: 'ums-resource' }
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/sys/resource/categoryList'),
        meta: { title: 'resourceCategory' },
        hidden: true
      },
      {
        path: 'dict',
        name: 'dict',
        component: () => import('@/views/sys/dict/index'),
        meta: { title: 'dataDictionary', icon: 'product-list' },
        hidden: false
      },
      {
        path: 'addDict',
        name: 'addDict',
        component: () => import('@/views/sys/dict/add'),
        meta: { title: 'addCodeTable', icon: 'dict-add' },
        hidden: true
      },
      {
        path: 'updateDict',
        name: 'updateDict',
        component: () => import('@/views/sys/dict/update'),
        meta: { title: 'updateCodeTable', icon: 'dict-update' },
        hidden: true
      },
      {
        path: 'websites',
        name: 'websites',
        component: () => import('@/views/sys/website/listWebsite'),
        meta: { title: 'websiteList', icon: 'product-list' },
        hidden: false
      },
      {
        path: 'updateWebsite',
        name: 'updateWebsite',
        component: () => import('@/views/sys/website/updateWebsite'),
        meta: { title: 'modifySiteConfiguration' },
        hidden: true
      },
      {
        path: 'webLog',
        name: 'webLog',
        component: () => import('@/views/sys/webLog/index'),
        meta: { title: 'foregroundLogList', icon: 'product-list' },
        hidden: true
      },
      {
        path: 'adminLog',
        name: 'adminLog',
        component: () => import('@/views/sys/adminLog/index'),
        meta: { title: 'backgroundLogList', icon: 'product-list' },
        hidden: true
      },
      {
        path: 'seoConfig',
        name: 'seoConfig',
        component: () => import('@/views/sys/seoConfig'),
        meta: { title: 'seoConfig', icon: 'product-list' },
        hidden: false
      },
      {
        path: 'imageConfig',
        name: 'imageConfig',
        component: () => import('@/views/sys/imageConfig'),
        meta: { title: 'imageConfig', icon: 'product-list' },
        hidden: false
      }
    ]
  }
  // { path: '*', redirect: '/404', hidden: true }
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js